module.exports = __webpack_public_path__ + "img/search.39f2f84b.svg";